import React, { useState } from 'react';
import SidebarMenu from "../components/SidebarMenu";
import { TabMenu } from 'primereact/tabmenu';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import '../styles/layout.css';

// Yönetici altı componentler
import ApproveLeaves from '../components/management/ApproveLeaves';
import ApproveExpenses from '../components/management/ApproveExpenses';
import SkillManagement from "../components/management/SkillManagement";

function ManagementPage() {
  const [activeIndex, setActiveIndex] = useState(0);

  const items = [
    { label: 'İzin Onayları', icon: 'pi pi-check-square' },
    { label: 'Harcama Onayları', icon: 'pi pi-wallet' },
    { label: 'Yetenek Yönetimi', icon: 'pi pi-wallet' }
  ];

  const renderComponent = () => {
    switch (activeIndex) {
      case 0: return <ApproveLeaves />;
      case 1: return <ApproveExpenses />;
      case 2: return <SkillManagement />;
      default: return null;
    }
  };

  return (
    <div className="layout">
      <SidebarMenu />
      <main className="content">
        <TabMenu
          model={items}
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
        />
        <div className="tab-content" style={{ marginTop: '1rem' }}>
          {renderComponent()}
        </div>
      </main>
    </div>
  );
}

export default ManagementPage;
